import { c as _c } from "react/compiler-runtime";
import React from "react";
import WaveWinnersDropHeaderTotalVotes from "./WaveWinnersDropHeaderTotalVotes";
import WaveWinnersDropHeaderVoters from "./WaveWinnersDropHeaderVoters";
import WaveWinnersDropHeaderAuthorHandle from "./WaveWinnersDropHeaderAuthorHandle";
import type { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import WinnerDropBadge from "@/components/waves/drops/winner/WinnerDropBadge";
import WaveDropTime from "@/components/waves/drops/time/WaveDropTime";
import { DropAuthorBadges } from "@/components/waves/drops/DropAuthorBadges";
import ApprovalStatusBadge from "@/components/waves/approval/ApprovalStatusBadge";
interface WaveWinnersDropHeaderProps {
  readonly winner: ApiWaveDecisionWinner;
  readonly showVotingInfo?: boolean | undefined;
  readonly isApprovalWave?: boolean | undefined;
}
export const WaveWinnersDropHeader: React.FC<WaveWinnersDropHeaderProps> = t0 => {
  const $ = _c(23);
  const {
    winner,
    showVotingInfo: t1,
    isApprovalWave: t2
  } = t0;
  const showVotingInfo = t1 === undefined ? true : t1;
  const isApprovalWave = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== winner) {
    t3 = <WaveWinnersDropHeaderAuthorHandle winner={winner} />;
    $[0] = winner;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = `winner-author-badges-${winner.drop.id}`;
  let t5;
  if ($[2] !== t4 || $[3] !== winner.drop.author) {
    t5 = <DropAuthorBadges profile={winner.drop.author} tooltipIdPrefix={t4} />;
    $[2] = t4;
    $[3] = winner.drop.author;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== isApprovalWave || $[6] !== winner.drop.winning_context?.decision_time || $[7] !== winner.place) {
    t6 = isApprovalWave ? <ApprovalStatusBadge approvedAt={winner.drop.winning_context?.decision_time ?? null} order={winner.place} /> : <WinnerDropBadge rank={winner.place} decisionTime={winner.drop.winning_context?.decision_time ?? null} />;
    $[5] = isApprovalWave;
    $[6] = winner.drop.winning_context?.decision_time;
    $[7] = winner.place;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="tw-size-[3px] tw-flex-shrink-0 tw-rounded-full tw-bg-iron-600" />;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== winner.drop.created_at) {
    t8 = <WaveDropTime timestamp={winner.drop.created_at} />;
    $[10] = winner.drop.created_at;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t3 || $[13] !== t5 || $[14] !== t6 || $[15] !== t8) {
    t9 = <div className="tw-flex tw-w-full tw-flex-wrap tw-items-center tw-gap-x-1.5 tw-gap-y-1 xl:tw-w-auto">{t3}{t5}{t6}{t7}{t8}</div>;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== showVotingInfo || $[18] !== winner) {
    t10 = showVotingInfo && <div className="tw-mt-1 tw-whitespace-nowrap sm:tw-mt-0"><div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-2 tw-gap-y-2 sm:tw-gap-x-4 xl:tw-flex-nowrap"><WaveWinnersDropHeaderTotalVotes winner={winner} /><WaveWinnersDropHeaderVoters winner={winner} /></div></div>;
    $[17] = showVotingInfo;
    $[18] = winner;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t9) {
    t11 = <div onClick={_temp} className="tw-flex tw-w-full tw-flex-wrap tw-justify-between tw-gap-y-2 xl:tw-flex-nowrap">{t9}{t10}</div>;
    $[20] = t10;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
};
function _temp(e) {
  return e.stopPropagation();
}